import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { PresignedURLTypesEnum } from '@Types';
import { useCallback } from 'react';

export interface GetPresignedUrlRequest {
  presigned_url_type: PresignedURLTypesEnum;
  filename: string;
  organization_id: number;
  [key: string]: any; // Request must include any additional fields required by specific file model types (e.g., document_subtype: "GOVERNING_DOCUMENT", custom_field: "some value", etc).
}

export interface GetPresignedUrlResponse {
  upload_url: string; // Presigned URL for uploading the file to S3.
  instance_id: number; // ID of the uploaded file model instance, used by the back end when the form is submitted to determine which file(s) the user has saved.
}

export const useGetPresignedUrl = () => {
  const [fetch, requestState] = useRequest<GetPresignedUrlResponse>();

  const getPresignedUrl = useCallback(
    (request: GetPresignedUrlRequest) => {
      return fetch(API.paths.get_presigned_url, 'post', { data: request });
    },
    [fetch],
  );

  return [getPresignedUrl, requestState] as const;
};
